<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="4">
          <v-combobox
            :items="months"
            label="Payroll Month"
            v-model="selectedMonth"
          ></v-combobox>
        </v-col>

        <v-col cols="4">
          <v-combobox
            :items="years"
            label="Payroll Year"
            v-model="selectedYear"
          ></v-combobox>
        </v-col>

        <v-col cols="4">
          <DatePickerWithMenu
            @date-selected="getPayrollDate"
          ></DatePickerWithMenu>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col cols="4"> </v-col>

        <v-col cols="4">
          <v-btn
            large
            outlined
            v-if="selectedMonth"
            :color="getOutlineColor"
            rounded
            @click="createPayrol()"
            >Create Payroll</v-btn
          >
        </v-col>

        <v-col cols="4"> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
import axios from "@/plugins/axios";

export default {
  components: { DatePickerWithMenu },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  data: () => ({
    selectedDate: new Date().toISOString().substr(0, 10),
    selectedMonth: null,
    selectedYear: new Date().getFullYear(),
    years: [
      new Date().getFullYear(),
      new Date().getFullYear() + 1,
      new Date().getFullYear() + 2,
      new Date().getFullYear() + 3,
    ],
    months: [
      { text: "January", value: 1 },
      { text: "Febraury", value: 2 },
      { text: "March", value: 3 },
      { text: "April", value: 4 },
      { text: "May", value: 5 },
      { text: "June", value: 6 },
      { text: "July", value: 7 },
      { text: "August", value: 8 },
      { text: "September", value: 9 },
      { text: "October", value: 10 },
      { text: "November", value: 11 },
      { text: "December", value: 12 },
    ],
  }),
  methods: {
    getPayrollDate(selectedDate) {
      this.selectedDate = selectedDate;
    },
    createPayrol() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/create-payroll",
          {
            month: this.selectedMonth.value,
            year: this.selectedYear,
            payDate: this.selectedDate,
          },
          this.getAccessToken
        )
        .then((payrolls) => {
          this.$emit("payroll-created", payrolls);
          this.$store.commit("setLoader", false);
        });
    },
  },
};
</script>

<style></style>
